<!-- document-types-list.component.html -->
<div class="w-full flex flex-col h-full min-h-0 min-w-[250px]">
    <div
        class="flex flex-col w-full border shadow-sm border-gray-200 rounded-base p-2 sm:p-3 h-full min-h-0 overflow-hidden">
        <div class="flex flex-col h-full min-h-0">
            <div class="flex flex-row items-center sticky top-0 bg-white z-10 pb-2 flex-shrink-0"
                [ngClass]="showHeading ? 'justify-between': 'justify-end'">
                @if(showHeading){
                <h3 class="font-bold text-base sm:text-lg">Document Types</h3>
                }
            </div>

            <div class="xl:my-1 2xl:my-2 items-center flex flex-col sm:flex-row gap-2 flex-shrink-0">
                <app-search-bar placeholder="Search document type" [(ngModel)]="searchDocTypes"
                    (searchChange)="onDocTypesFilter()" class="flex-1 w-full" [disabled]="docTypeLoading">
                </app-search-bar>
                <app-button *ngIf="showAddButton" label="Add" severity="primary" icon="pi pi-plus"
                    (clicked)="addDocType()" class="w-full sm:w-auto" />
            </div>

            <div #docTypeContainer class="overflow-y-auto flex-1 min-h-0">
                @if(docTypeLoading){
                @for (item of getSkeletonCount(6); track $index) {
                <div class="w-full h-20 pt-2">
                    <p-skeleton width="100%" height="90%" />
                </div>
                }
                }
                @else{
                @if(!filteredDocTypes.length) {
                <p class="text-center mt-7">No Document Types found</p>
                }
                @for (keyPoint of filteredDocTypes; track keyPoint._id) {
                <div class="flex flex-col gap-2 border p-2 sm:p-4 my-2 rounded-base"
                    [class.active-key-point]="selectedDocType._id === keyPoint._id"
                    [class.cursor-pointer]="isSelectable" (click)="isSelectable ? selectKeyPoint(keyPoint) : null">
                    <div class="flex flex-row flex-wrap gap-2 w-full items-start sm:items-center justify-between">
                        <div class="flex flex-row gap-2 items-start sm:items-center flex-1 min-w-[60%]">
                            <span
                                class="border p-1.5 sm:p-2 rounded-base key-point-icon inline-flex items-center justify-center flex-shrink-0">
                                <i class="pi pi-file text-sm sm:text-base"></i>
                            </span>
                            <div class="flex flex-col min-w-0 flex-1">
                                <span class="font-bold truncate text-sm sm:text-base">{{keyPoint.name}}</span>
                                <span class="text-gray-500 line-clamp-1 text-xs sm:text-sm w-fit max-w-full"
                                    [pTooltip]="keyPoint.description">
                                    {{keyPoint.description}}
                                </span>
                            </div>
                        </div>
                        <div class="flex flex-row items-center gap-2 flex-shrink-0">
                            @if(keyPoint.containsForm){
                            <p-tag value="Contains Form" severity="info"
                                class="!text-xs !p-1 !whitespace-nowrap !rounded-base !bg-arena-blue-100 !text-arena-blue" />
                            }
                            @if(showMenu){
                            <app-popover width="12rem" #popover>
                                <ng-template #trigger>
                                    <div class="user cursor-pointer">
                                        <i class="pi pi-ellipsis-v"></i>
                                    </div>
                                </ng-template>

                                <ng-template #body>
                                    <div class="flex flex-col gap-1">
                                        <div class="flex flex-row items-center py-2 px-3 cursor-pointer hover:bg-gray-100 rounded"
                                            (click)="handleMenuItemClick({label: 'Edit', icon: 'pi pi-pencil'}, keyPoint, popover)">
                                            <span class="pi pi-pencil"></span>
                                            <span class="ml-2">Edit</span>
                                        </div>
                                        <div class="flex flex-row items-center py-2 px-3 cursor-pointer hover:bg-gray-100 rounded"
                                            (click)="handleMenuItemClick({label: 'Custom Summary', icon: 'pi pi-file-edit'}, keyPoint, popover)">
                                            <span class="pi pi-file-edit"></span>
                                            <span class="ml-2">Custom Summary</span>
                                        </div>
                                        <div class="flex flex-row items-center py-2 px-3 cursor-pointer hover:bg-gray-100 rounded"
                                            (click)="handleMenuItemClick({label: 'Custom KPI\'s', icon: 'pi pi-chart-bar'}, keyPoint, popover)">
                                            <span class="pi pi-chart-bar"></span>
                                            <span class="ml-2">Custom KPI's</span>
                                        </div>
                                        <div class="flex flex-row items-center py-2 px-3 cursor-pointer hover:bg-gray-100 rounded"
                                            (click)="handleMenuItemClick({label: 'Delete', icon: 'pi pi-trash'}, keyPoint, popover)">
                                            <span class="pi pi-trash text-danger"></span>
                                            <span class="ml-2 text-danger">Delete</span>
                                        </div>
                                    </div>
                                </ng-template>
                            </app-popover>
                            }
                        </div>
                    </div>
                </div>
                }
                }
            </div>
        </div>
    </div>

    <!-- Add/Edit Dialog -->
    <app-dialog [(visible)]="addDialogVisible" [title]="edit ? 'Edit ' + selectedDocType.name : 'Add Document Type'"
        (closed)="addDialogVisible = false" class="max-w-[600px]" [fullscreenOnMobile]="true">
        <ng-template #bodyTemplate>
            @if (addEditDocType) {
            <div class="flex flex-col gap-4 p-4">
                <div class="flex flex-col gap-1">
                    <label for="name">Name <span class="text-danger">*</span></label>
                    <input pInputText id="name" class="flex-auto border rounded-base input" autocomplete="off"
                        [(ngModel)]="addEditDocType.name" required #name="ngModel" />
                    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger text-xs">
                        {{"Name is required." | titlecase}}
                    </div>
                </div>
                <div class="flex flex-col gap-1">
                    <label for="description">Description <span class="text-danger">*</span></label>
                    <textarea pInputText id="description" class="flex-auto border rounded-base input" autocomplete="off"
                        [(ngModel)]="addEditDocType.description" required #description="ngModel"></textarea>
                    <div *ngIf="description.invalid && (description.dirty || description.touched)"
                        class="text-danger text-xs">
                        {{"Description is required." | titlecase}}
                    </div>
                </div>
                <div class="flex flex-row items-center gap-3">
                    <label for="containsForm">Does this document type contains a form?</label>
                    <app-toggle [(ngModel)]="addEditDocType.containsForm" inputId="containsForm" class="primary"
                        [disabled]="edit && !!selectedDocType.standardDocumentType"></app-toggle>
                </div>
            </div>
            }
        </ng-template>
        <ng-template #footerTemplate>
            <div class="flex justify-end gap-2">
                <app-button variant="filled" severity="primary" label="Add" (clicked)="saveDocType('addDocType')"
                    [disabled]="docTypeSaveLoading" />
            </div>
        </ng-template>
    </app-dialog>

    <!-- Custom Summary Dialog -->
    <app-dialog [(visible)]="customSummaryDialog.visible" [title]="'Add ' + customSummaryDialog.type"
        (closed)="customSummaryDialog.visible = false" class="max-w-[600px]" [fullscreenOnMobile]="true">
        <ng-template #bodyTemplate>
            <div class="flex flex-col gap-1 p-4">
                <label for="summaryDescription">{{customSummaryDialog.type}} Description</label>
                <textarea pInputText id="summaryDescription" class="flex-auto border rounded-base input" rows="6"
                    autocomplete="off" [(ngModel)]="addEditDocType.summaryDescription"></textarea>
            </div>
        </ng-template>
        <ng-template #footerTemplate>
            <div class="flex justify-end gap-2">
                <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                    (clicked)="this.customSummaryDialog.visible=false" />
                <app-button variant="filled" severity="primary" label="Save" icon="pi pi-save"
                    (clicked)="saveDocType('customSummary')" [disabled]="docTypeSaveLoading" />
            </div>
        </ng-template>
    </app-dialog>

    <!-- Custom KPIs Dialog -->
    <app-dialog [(visible)]="customComparisonDialogVisible" title="Custom Key Performance Indicators"
        (closed)="customComparisonDialogVisible = false" class="max-w-[700px]" [fullscreenOnMobile]="true">
        <ng-template #bodyTemplate>
            <div class="flex flex-col gap-3 p-4">
                <div class="flex flex-row justify-end">
                    <app-button variant="filled" label="Add" severity="primary" icon="pi pi-plus"
                        (clicked)="openAddKpiDialog()" />
                </div>
                <div class="flex flex-col gap-2 max-h-[55vh] overflow-y-auto">
                    @if(addEditDocType.customKpis?.length) {
                    @for(kpi of addEditDocType.customKpis; track $index; let i = $index) {
                    <p-card class="tag-card">
                        <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-2">
                            <div class="flex flex-col mr-2 flex-1 min-w-0">
                                <div class="font-bold break-words text-sm sm:text-base">{{kpi.name}}</div>
                                <div class="truncate-text text-gray-500 text-xs sm:text-sm"
                                    [pTooltip]="kpi.description">{{kpi.description}}</div>
                            </div>
                            <div class="flex flex-row items-center gap-2 flex-shrink-0 self-end sm:self-center">
                                <app-button variant="outlined" icon="pi pi-pencil"
                                    (clicked)="openAddKpiDialog('Edit', kpi)" />
                                <app-button variant="outlined" severity="danger" icon="pi pi-trash"
                                    (clicked)="removeKpi(kpi._id)" />
                            </div>
                        </div>
                    </p-card>
                    }
                    }
                    @else {
                    <p class="text-center">No Custom Key Performance Indicators found</p>
                    }
                </div>
            </div>
        </ng-template>
        <ng-template #footerTemplate>
            <div class="flex justify-end gap-2">
                <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                    (clicked)="this.customComparisonDialogVisible=false" />
                <app-button variant="filled" severity="primary" label="Save" icon="pi pi-save"
                    (clicked)="saveDocType('customKpis')" [disabled]="docTypeSaveLoading" />
            </div>
        </ng-template>
    </app-dialog>

    <!-- Add KPI Dialog -->
    <app-dialog [(visible)]="kpiDialog.visible" [title]="kpiDialog.mode + ' Custom Key Performance Indicators'"
        (closed)="onKpisDialogClose()" class="max-w-[600px]" [fullscreenOnMobile]="true">
        <ng-template #bodyTemplate>
            <div class="flex flex-col gap-4 p-4">
                <div class="flex flex-col gap-1">
                    <label for="kpiName">Name <span class="text-danger">*</span></label>
                    <input pInputText id="kpiName" class="flex-auto border rounded-base input" autocomplete="off"
                        [(ngModel)]="kpiName" required />
                </div>
                <div class="flex flex-col gap-1">
                    <label for="kpiDescription">Description <span class="text-danger">*</span></label>
                    <textarea pInputText id="kpiDescription" class="flex-auto border rounded-base input"
                        autocomplete="off" [(ngModel)]="kpiDescription"></textarea>
                </div>
            </div>
        </ng-template>
        <ng-template #footerTemplate>
            <div class="flex justify-end gap-2">
                <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                    (clicked)="this.kpiDialog.visible=false" />
                <app-button variant="filled" severity="primary" label="Save" icon="pi pi-save" (clicked)="saveKpi()"
                    [disabled]="docTypeSaveLoading" />
            </div>
        </ng-template>
    </app-dialog>

    @if(deleteDocTypeDialogVisible){
    <app-delete-confirmation [(visible)]="deleteDocTypeDialogVisible" headerText="Are you sure?"
        bodyText="This action will delete the document type" confirmButtonText="Proceed"
        (onConfirm)="confirmDeleteDocType()">
    </app-delete-confirmation>
    }
</div>